"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2022 BLUECROSS BLUESHIELD OF SOUTH CAROLINA ALL RIGHTS RESERVED.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USStateName = exports.Coverage = exports.HttpErrorCode = exports.HttpMethod = exports.Constituent = void 0;
/**
 * enums used in the applications
 */
__exportStar(require("./employer"), exports);
/**
 * the constituents
 * - member
 * - provider
 * - employer
 */
var Constituent;
(function (Constituent) {
    Constituent["MEMBER"] = "member";
    Constituent["PROVIDER"] = "provider";
    Constituent["EMPLOYER"] = "employer";
})(Constituent = exports.Constituent || (exports.Constituent = {}));
const ConstituentValueMap = {
    [Constituent.MEMBER]: 'member',
    [Constituent.PROVIDER]: 'provider',
    [Constituent.EMPLOYER]: 'employer'
};
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["PATCH"] = "PATCH";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
/**
 * Provide an enumeration for http error codes
 */
var HttpErrorCode;
(function (HttpErrorCode) {
    /**
     * LEDS Token expired
     */
    HttpErrorCode[HttpErrorCode["LEDS_TOKEN_EXPIRED"] = 419] = "LEDS_TOKEN_EXPIRED";
    HttpErrorCode[HttpErrorCode["COMM_SERVICES_TOKEN_EXPIRED"] = 401] = "COMM_SERVICES_TOKEN_EXPIRED";
})(HttpErrorCode = exports.HttpErrorCode || (exports.HttpErrorCode = {}));
/**
 * The Insurance Coverage Types
 */
var Coverage;
(function (Coverage) {
    Coverage["HEALTH"] = "HEALTH";
    Coverage["DENTAL"] = "DENTAL";
    Coverage["DRUG"] = "DRUG";
    Coverage["VISION"] = "VISION";
    Coverage["UNKNOWN"] = "";
})(Coverage = exports.Coverage || (exports.Coverage = {}));
var USStateName;
(function (USStateName) {
    USStateName["ALABAMA"] = "AL";
    USStateName["ALASKA"] = "AK";
    USStateName["ARIZONA"] = "AZ";
    USStateName["ARKANSAS"] = "AR";
    USStateName["CALIFORNIA"] = "CA";
    USStateName["COLORADO"] = "CO";
    USStateName["CONNECTICUT"] = "CT";
    USStateName["DELAWARE"] = "DE";
    USStateName["FLORIDA"] = "FL";
    USStateName["GEORGIA"] = "GA";
    USStateName["HAWAII"] = "HI";
    USStateName["IDAHO"] = "ID";
    USStateName["ILLINOIS"] = "IL";
    USStateName["INDIANA"] = "IN";
    USStateName["IOWA"] = "IA";
    USStateName["KANSAS"] = "KS";
    USStateName["KENTUCKY"] = "KY";
    USStateName["LOUISIANA"] = "LA";
    USStateName["MAINE"] = "ME";
    USStateName["MARYLAND"] = "MD";
    USStateName["MASSACHUSETTS"] = "MA";
    USStateName["MICHIGAN"] = "MI";
    USStateName["MINNESOTA"] = "MN";
    USStateName["MISSISSIPPI"] = "MS";
    USStateName["MISSOURI"] = "MO";
    USStateName["MONTANA"] = "MT";
    USStateName["NEBRASKA"] = "NE";
    USStateName["NEVADA"] = "NV";
    USStateName["NEW_HAMPSHIRE"] = "NH";
    USStateName["NEW_JERSEY"] = "NJ";
    USStateName["NEW_MEXICO"] = "NM";
    USStateName["NEW_YORK"] = "NY";
    USStateName["NORTH_CAROLINA"] = "NC";
    USStateName["NORTH_DAKOTA"] = "ND";
    USStateName["OHIO"] = "OH";
    USStateName["OKLAHOMA"] = "OK";
    USStateName["OREGON"] = "OR";
    USStateName["PENNSYLVANIA"] = "PA";
    USStateName["RHODE_ISLAND"] = "RI";
    USStateName["SOUTH_CAROLINA"] = "SC";
    USStateName["SOUTH_DAKOTA"] = "SD";
    USStateName["TENNESSEE"] = "TN";
    USStateName["TEXAS"] = "TX";
    USStateName["UTAH"] = "UT";
    USStateName["VERMONT"] = "VT";
    USStateName["VIRGINIA"] = "VA";
    USStateName["WASHINGTON"] = "WA";
    USStateName["WEST_VIRGINIA"] = "WV";
    USStateName["WISCONSIN"] = "WI";
    USStateName["WYOMING"] = "WY";
})(USStateName = exports.USStateName || (exports.USStateName = {}));
//# sourceMappingURL=index.js.map